import React from "react";

const SwitchActiveBetsColum = ({ showBetsColumn, setShowBetsColumn }) => {
  const toggleBetsColumn = () => {
    setShowBetsColumn(!showBetsColumn);
  };

  return (
    <div className="custom-control custom-switch mb-2 mt-1">
      <input
        type="checkbox"
        className="custom-control-input"
        id="switchColumnBetsEvent"
        name="columnBets"
        onClick={() => toggleBetsColumn()}
      />
      <label
        className="custom-control-label lead"
        htmlFor="switchColumnBetsEvent"
        style={{ color: "#888", fontSize: "18px" }}
      >
        View #Bets
      </label>
    </div>
  );
};

export default SwitchActiveBetsColum;
